import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "../styles/header.css";
import ChatComponent from "../components/ChatComponent";

const Header = () => {
  const [showChat, setShowChat] = useState(false);
  const [user, setUser] = useState(null);
  const [room, setRoom] = useState(null); // Make room dynamic
  const [loading, setLoading] = useState(true);
  const marqueeRef = useRef(null);

  useEffect(() => {
    initializeUser();
  }, []);

  const initializeUser = async () => {
    try {
      console.log("=== INITIALIZING USER ===");

      // Check if user is logged in (has token)
      const token = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      if (token && storedUser) {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser.id && !parsedUser._id) {
          parsedUser._id = parsedUser.id;
        }

        setUser(parsedUser);

        // Create unique room for this user
        setRoom(`chat_${parsedUser._id}`);
      } else {
        // Guest user - check if already created
        const guestId = localStorage.getItem("guestUserId");

        const response = await axios.post("/api/v1/guest/create-guest", {
          guestId: guestId || null,
        });

        if (response.data.success) {
          const guestUser = response.data.user;

          setUser(guestUser);
          localStorage.setItem("guestUserId", guestUser._id);

          // Create unique room for this guest
          setRoom(`chat_${guestUser._id}`);
        }
      }
    } catch (error) {
      console.error("❌ Error initializing user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMouseEnter = () => {
    marqueeRef.current?.stop();
  };

  const handleMouseLeave = () => {
    marqueeRef.current?.start();
  };

  if (loading) {
    return (
      <>
        <div className="header-main">
          <marquee
            behavior="scroll"
            direction="left"
            scrollamount="5"
            ref={marqueeRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <span>
              "Strategic Alliance for Admissions, Recruitement, Development, and
              Resource Planning"
            </span>
            <span>
              <i className="fa-solid fa-envelope"></i> Email: info@drp.org.in
            </span>
            <span>
              <i className="fa-solid fa-phone"></i> Call us: +91 9699657891
            </span>
          </marquee>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Marquee Header */}
      <div className="header-main">
        <marquee
          behavior="scroll"
          direction="left"
          scrollamount="5"
          ref={marqueeRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <span>
            "Strategic Alliance for Admissions, Recruitement, Development, and
            Resource Planning"
          </span>
          <span>
            <i className="fa-solid fa-envelope"></i> Email: info@drp.org.in
          </span>
          <span>
            <i className="fa-solid fa-phone"></i> Call us: +91 9699657891
          </span>
        </marquee>
      </div>

      {/* Floating Chat Button */}
      <button
        onClick={() => {
          console.log("💬 Chat button clicked");
          console.log("User:", user);
          console.log("Room:", room);
          setShowChat(!showChat);
        }}
        className="floating-chat-btn"
      >
        💬
      </button>

      {/* Chat Window */}
      {showChat && user && room && (
        <div className="floating-chat-window">
          <ChatComponent user={user} room={room} />
        </div>
      )}
    </>
  );
};

export default Header;
